import styled from "@emotion/styled";
import { Button, Typography } from "@kaltura/ds-react-components";
import { translate } from "@kaltura/mediaspace-shared-utils";

export interface LoadMoreButtonProps {
    /**
     * Whether the button is in loading state
     */
    isLoading: boolean;
    /**
     * Whether there are more items to load
     */
    hasMore: boolean;
    /**
     * Callback when button is clicked
     */
    onLoadMore: () => void;
    /**
     * Optional custom label
     */
    label?: string;
}

const LoadMoreContainer = styled("div")(({ theme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: theme.spacing(2),
}));

const NoMoreMediaText = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
}));

/**
 * Load More Button component - displays a button to load more results
 * Loading state is handled by parent component via skeleton display
 */
export function LoadMoreButton(props: LoadMoreButtonProps) {
    const { isLoading, hasMore, onLoadMore, label = translate("Load more") } = props;

    if (!hasMore) {
        return (
            <LoadMoreContainer>
                <NoMoreMediaText variant={"body1Highlight"}>{translate("No more media available")}</NoMoreMediaText>
            </LoadMoreContainer>
        );
    }

    return (
        <LoadMoreContainer>
            <Button color="secondary" onClick={onLoadMore} disabled={isLoading} aria-label={label}>
                {label}
            </Button>
        </LoadMoreContainer>
    );
}

export default LoadMoreButton;
